import React, { forwardRef, useEffect, useState } from "react";
import "./CustomRadio.scss";

type Option = {
  label: string;
  value: string | string[];
};

type Props = {
  options: Option[];
  selectedValue: string | string[];
  onChange: (value: string | string[]) => void;
};

const CustomRadio = forwardRef<HTMLElement, Props>(
  ({ options, selectedValue, onChange }, refinput) => {
    const [value, setValue] = useState<string | string[]>(selectedValue);

    useEffect(() => {
      setValue(selectedValue);
    }, [options, selectedValue]);

    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = event.target.value;
      setValue(newValue);
      onChange(newValue);
    };

    return (
      <div className="custom-radio">
        {options.map((option) => {
          return (
            <label className="radio-label" key={option.label}>
              <input
                type="radio"
                value={option.value}
                checked={value == option.value}
                onChange={handleRadioChange}
              />
              <span className="radio-button"></span>
              {option.label}
            </label>
          );
        })}
      </div>
    );
  }
);

export default CustomRadio;
